<template>
  <!-- 
  Author: sss
  Date: 2021-10-26
  content: 上市企业榜
-->
  <div class="vb100">
    <div class="p_head">
      <div class="p_title">
        <p>TOP 50 INNOVATIVE PUBLIC COMPANIES</p>
        <h1>上市企业榜</h1>
      </div>
      <div class="p_links">
        <div class="links-item js-lower-anchor" @click="toA('#list-info')">
          <p class="links-name">
            <span class="links-index">01</span>上市企业榜介绍
          </p>
          <i class="el-icon-bottom"></i>
        </div>
        <div class="links-item js-lower-anchor" @click="toA('#list-table')">
          <p class="links-name">
            <span class="links-index">02</span>历届上市企业榜
          </p>
          <i class="el-icon-bottom"></i>
        </div>
      </div>
    </div>
    <div class="p_image">
      <div class="p_image_inner">
        <img src="~/img/main/ss.png" />
      </div>
    </div>
    <div class="list-content" id="list-info">
      <!-- 榜单介绍 -->
      <div class="info">
        <div class="list-title">上市企业榜介绍</div>
        <div class="list-desc">{{introduce}}</div>
      </div>
    </div>
    <!-- 历届榜单 -->
    <div class="his-content" id="list-table">
      <div class="list-content">
        <div class="info">
          <div class="list-title">上市企业榜</div>
          <div class="list-png">
            <img src="~/img/main/list.png" />
          </div>
        </div>
      </div>
    </div>
    <!-- 表格 -->
    <div class="list-wap">
      <div class="award-title">
        <img src="~/img/main/left.png" class="title-left" />
        <div class="list-name">
          <p>{{ year_name }}</p>
          <h1>{{top_name}}</h1>
        </div>
        <img src="~/img/main/right.png" class="title-right" />
      </div>
      <div class="list-table" ref="table">
        <div class="business-card">
            <div class="card-content" v-for="result in tableData" :key="result.id" >
              <div>
                <a v-if="getResult2(result)" @click="getResult2(result)">
                    <img :src="$store.state.img_req_url + getLogo(result)" alt="">
                  </a>
                <img v-else :src="$store.state.img_req_url + getLogo(result)" alt="">
              </div>
              <p class="card-title">{{result}}</p>
            </div>
          </div>
        </div>
        <div class="remark" v-html="detail.remarks"></div>
      </div>
    <!-- 锚点 -->
    <div class="condition" v-if="is_condition">
      <div class="condition-item">
        <el-dropdown placement="top" @command="openYear" trigger="click">
          <span class="el-dropdown-link">
            {{ year_id | dealNeed(anchor_list, "name", "全部")}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="item.id" v-for="item in anchor_list" :key="item.id">{{ item.name }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="condition-item">
        <el-dropdown placement="top" @command="changeType" trigger="click">
          <span class="el-dropdown-link">
            {{ top_name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="over-p1" :command="item.id" v-for="item in  tag_list" :key="item.id">
                <span v-if="type == '2'" class="sign">报名中</span>
                {{item.title}}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { getAwardsYearList, getVbTopListById } from "@/service/main.js";
import { list_mixin, scroll_mixin } from "mjs/list_mixins";
import filter from '@/assets/js/filter.js'
export default {
  mixins: [list_mixin, scroll_mixin],
  data() {
    return {
      tableData: [],
      loading: false,
      anchor_list: [],
      tag_list: [],
      top_list_id: "", //当前奖项的id
      year_id: "", //当前年id
      top_name: "", //当前奖项的id
      year_name: "", //当前年id
      detail: "", //当前奖项的详情
      is_condition: true,
      awards_list: [],
      type: ''
    };
  },
  computed: {
    list_meta() {
      return this.$store.state.list_meta;
    },
    awards_id() {
      let id = this.$store.state.list_meta.awards_meta.find(
        (item) => item.route == this.$route.name
      ).id;
      return id;
    },
    introduce() {
      let introduce = this.$store.state.list_meta.awards_meta.find(item => item.route == this.$route.name).introduce
      return introduce
    }
  },
  mounted() {
    let _this = this;
    this.$nextTick(() => {
      window.onscroll = () => {
        _this.listenerScroll();
      };
    });
  },
  beforeDestroy() {
    window.onscroll = null;
  },
  created() {
    this.getAwardsYearList();
  },
  methods: {
    // 锚点跳转
    toA(id) {
      $("html,body").animate({ scrollTop: $(id).offset().top  }, 500);
    },
    //获取年数据
    async getAwardsYearList() {
      let res = await getAwardsYearList(
        {
          awards_id: this.awards_id,
        },
        (error) => {
          this.$Message.error("请求错误");
        }
      );
      if (res.status == "success") {
        let arr = res.res.filter((item) => item.topList.length > 0);
        this.$set(this.$data, "anchor_list", arr);
        let temp = this.anchor_list.find((item) => item.type == "1");
        this.tag_list = temp.topList;
        this.top_list_id = temp.topList[0].id;
        this.top_name = temp.topList[0].title;
        this.year_id = temp.id;
        this.year_name = temp.name; 
        this.type = temp.type
        this.getVbTopListById();
      } else {
        this.$Message.error(res.msg);
      }
    },
    //获取历届榜单
    async getVbTopListById() {
      this.awards_list = [];
      let res = await getVbTopListById(
        {
          top_list_id: this.top_list_id
        },
        (error) => {
          this.$Message.error("请求错误");
        }
      );
      if (res.status == 'success') {
        let deal_temp = this.dealListEntity(res.res.content)
        this.$set(this.$data, 'tableData', deal_temp.arr)
        this.$set(this.$data, 'detail', res.res)
        this.matching_results = res.res.matching_results ? JSON.parse(res.res.matching_results) : []
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    //单选按钮
    changeType(id) {
      let temp_y = this.anchor_list.find(item => item.id == this.year_id)
      let temp = this.tag_list.find(item => item.id == id)
      if(temp_y.type == '2'){
        temp.url ? window.open(temp.url, '_blank') : ''
      }else{
        this.top_list_id = temp.id
        this.top_name = temp.title
        let temp_y = this.anchor_list.find(item => item.id == this.year_id)
        this.year_name = temp_y.name
        $("html,body").animate({ scrollTop: $('#list-table').offset().top  }, 500)
        this.getVbTopListById(temp.id)
      }
    },
    //展开年
    openYear(id) {
      this.year_id = id;
      let temp = this.anchor_list.find((i) => i.id == id);
      this.year_name = filter.dealNeed(id, this.anchor_list)
      this.$set(this.$data, "tag_list", temp.topList);
      this.type = filter.dealNeed(id, this.anchor_list, 'type')
      this.$set(this.$data, 'tag_list', temp.topList)
    },
    listenerScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop; //滚动条的值
      let vh = document.documentElement.clientHeight;
      let footer = $(".footer").offset().top;
      if (top >= footer - vh) {
        this.is_condition = false;
      } else {
        this.is_condition = true;
      }
    },
    //处理实体 跳转
    getResult2(e) {
      let temp = this.matching_results.find(i => i.short_name == e)
      if(this.detail.jump == '1'){ //动脉橙
        if(temp && temp.uid){
          let route = temp.type == '0' ? 'companyDetail' : temp.type == '1' ? 'orgDetail' : 'hospitalDetail'
          return route + '/' + temp.uid
        }else{
          return ''
        }
      }else if(this.detail.jump == '2'){ //官网
        return temp && temp.main_page ? temp.main_page : ''
      }else{
        return ''
      }
    },
    getLogo(e){
      let entity = this.matching_results.find(i => i.short_name == e)
      return entity ? entity.logo_path : ''
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~mcss/main/list.stylus';
@import '~mcss/main/awardlist.stylus';
.list-wap
  padding-bottom .8rem
  .list-table
    background #181A23
.business-card
  width 100%
  display flex
  flex-wrap wrap
  justify-content center
.card-content
  margin-top .3rem
  width calc((100% - .7rem)/3)
  text-align center
  padding .1rem
  >div
    width 100%
    height .8rem
    background-color #fff
    display flex
    justify-content center
    align-items center
    a 
      display block 
      width 100%
      height 100%
      display flex
      justify-content center
      align-items center
    img
      max-width 100%
      // width 120px
      max-height 100%
  p
    margin-top .2rem
    font-size .2rem
    line-height .28rem
    color #FFFFFF
.condition
  width 100%
  height .95rem
  background #1F2330
  box-shadow 0px 2px 10px 0px rgba(14, 15, 20, 0.1)
  position fixed
  bottom 0
  left 0
  display flex
  >div 
    display flex 
    justify-content center
    align-items center
  .condition-item:nth-child(1)
    width 33%
    position relative 
    &::after
      position absolute
      right 0
      top 20%
      content ''
      width .02rem
      height 60%
      background #3D3D3D
  .condition-item:nth-child(2)
    width 66%

.footer 
  margin-top 0
.sign
  background #326CDB
  color #fff
  border-radius .1rem
  font-size .12rem
  padding .04rem .06rem
  white-space nowrap
</style>